<app-info-modal [infoModalData]="infoModalData"></app-info-modal>
